import React from 'react';
import ReactDOM from 'react-dom/client';

import sentryInit from './sentry/init';
import reportWebVitals from './reportWebVitals';
import MainRoutes from './routes/main';

sentryInit();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
	<React.StrictMode>
		<MainRoutes />
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
